import { render } from "./Transactions.vue?vue&type=template&id=09741e5d"
import script from "./Transactions.vue?vue&type=script&lang=js"
export * from "./Transactions.vue?vue&type=script&lang=js"
script.render = render

export default script